import { Pipe, PipeTransform } from '@angular/core';

const PRESETS = {
  monthShort: { month: 'short' },
  monthLong: { month: 'long' },
  dayMonth: { day: 'numeric', month: 'long' },
  monthYear: { month: 'long', year: 'numeric' },
  mediumDate: { dateStyle: 'medium' },
  longDate: { dateStyle: 'long' },
} satisfies Record<string, Intl.DateTimeFormatOptions>;

export type LocalizedDatePreset = keyof typeof PRESETS;

@Pipe({
  name: 'localizedDate',
})
export class LocalizedDatePipe implements PipeTransform {
  transform(
    value: Nullable<number | string | Date> | undefined,
    preset: LocalizedDatePreset,
    locale: string
  ): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const date = new Date(value);

    if (isNaN(date.getTime())) {
      return '';
    }

    return new Intl.DateTimeFormat(locale, PRESETS[preset]).format(date);
  }
}
